import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Slider from 'react-slick';
import { compose } from 'redux';
import * as styles from './style';
import AddNewStep from './CustomSteps/AddNewStep';
import AddonStep from './CustomSteps/AddonStep';
import SelectProductsModal from '../SelectProductsModal';
import withProducts from '../../containers/Products';
import withCreateProductAddons from '../../containers/CreateProductsAddons';
import { PRODUCT_ADDONS, PRODUCT_ADDONS_TYPE } from '../../helpers/constants';
import withVariations from '../../containers/GlobalVariations';
import SelectVariationsModal from '../SelectVariationsModal';

const CAROUSEL_SETTINGS = setDragging => ({
  arrows: false,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  swipeToSlide: true,
  adaptiveHeight: true,
  beforeChange: () => setDragging(true),
  afterChange: () => setDragging(false),
});

const ProductAddons = ({
  addNewStep,
  productAddons,
  getAllProductsByStatus,
  isLoadingProducts,
  finishReceiveProducts,
  categories,
  closeStepDataModal,
  addStepData,
  getVariations,
  isLoadingVariations,
  finishReceiveVariations,
  variations,
  errorSteps,
  match,
}) => {
  const { steps, currStep } = productAddons;
  const [isDragging, setDragging] = useState(false);

  getProducts({ currStep, isLoadingProducts, getAllProductsByStatus, finishReceiveProducts });
  getGlobalVariations({ currStep, isLoadingVariations, getVariations, finishReceiveVariations });

  return (
    <styles.Container>
      <styles.Content>
        <Slider ref={slider => (this.slider = slider)} {...CAROUSEL_SETTINGS(setDragging)}>
          {steps.map((step, index) => (
            <AddonStep
              key={step.id}
              step={step}
              order={index + 1}
              error={errorSteps.some(error => error.id === step.id)}
              goToSlide={i => this.slider.slickGoTo(i)}
              currentIndex={index}
              lastIndex={steps.length - 1}
            />
          ))}
          <AddNewStep addStep={addNewStep} isDragging={isDragging} />
        </Slider>
      </styles.Content>
      <SelectProductsModal
        categories={filterCategories(match.params.id, currStep.data || categories)}
        isOpen={currStep.addonType === PRODUCT_ADDONS.SELECTED_PRODUCTS}
        closeModal={closeStepDataModal}
        isLoading={isLoadingProducts}
        onSubmit={data => addStepData(currStep.id, data, PRODUCT_ADDONS.SELECTED_PRODUCTS)}
      />
      <SelectVariationsModal
        variations={filterVariations(variations, steps)}
        isOpen={currStep.addonType === PRODUCT_ADDONS.SELECTED_GLOBAL_VARIATIONS}
        isLoading={isLoadingVariations}
        closeModal={closeStepDataModal}
        onSubmit={data => addStepData(currStep.id, data, PRODUCT_ADDONS.SELECTED_GLOBAL_VARIATIONS)}
      />
    </styles.Container>
  );
};

const isProductDisabled = product => {
  return product.productType === PRODUCT_ADDONS_TYPE.PRODUCTS;
};

const filterCategories = (productId, categories) =>
  categories.map(cat => ({
    ...cat,
    products: cat.products
      .filter(prod => !productId || prod.id !== Number(productId))
      .map(prod => ({
        ...prod,
        disabled: isProductDisabled(prod, productId),
        disabledText: isProductDisabled(prod, productId) ? 'Este produto já é um combo' : null,
      })),
  }));

const filterVariations = (variations, steps) =>
  variations.filter(
    variation =>
      !steps.some(
        step =>
          step.addonType === PRODUCT_ADDONS.SELECTED_GLOBAL_VARIATIONS &&
          step.data.id === variation.id
      )
  );

const getProducts = ({
  currStep,
  isLoadingProducts,
  getAllProductsByStatus,
  finishReceiveProducts,
}) => {
  useEffect(() => {
    if (
      currStep.addonType === PRODUCT_ADDONS.SELECTED_PRODUCTS &&
      !isLoadingProducts &&
      !finishReceiveProducts
    ) {
      getAllProductsByStatus(1, true);
    }
  });
};

const getGlobalVariations = ({
  currStep,
  isLoadingVariations,
  getVariations,
  finishReceiveVariations,
}) => {
  useEffect(() => {
    if (
      currStep.addonType === PRODUCT_ADDONS.SELECTED_GLOBAL_VARIATIONS &&
      !isLoadingVariations &&
      !finishReceiveVariations
    ) {
      getVariations();
    }
  });
};

ProductAddons.propTypes = {
  errorSteps: PropTypes.array,
};

ProductAddons.defaultProps = {
  errorSteps: [],
};

export default compose(
  withCreateProductAddons,
  withProducts,
  withVariations,
  withRouter
)(ProductAddons);



// WEBPACK FOOTER //
// ./src/components/ProductAddons/index.js